import React from 'react';
import { TColumn } from './types';
import { useTranslation } from 'react-i18next';

interface IIsActiveRow {
    column: TColumn;
    item: any;
}

export const IsActiveRow = ({ column, item }: IIsActiveRow) => {
    const { t } = useTranslation();

    if (item.isActive === true || item.isActive === 'true') {
        return <span>{t('Users.Active')}</span>;
    }

    if (item.isActive === false || item.isActive === 'false') {
        return <span>{t('Users.Inactive')}</span>;
    }

    return <span>- - -</span>;
};
